import useFlyingAnimation from 'hooks/useFlyingAnimation';
import type { ButtonHTMLAttributes } from 'react';
import CoinIcon from 'assets/images/coin_icon.png';
import { motion, AnimatePresence } from 'framer-motion';

interface ButtonPropsType extends ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  className?: string;
}
import useIncrementNumber from 'hooks/useIncrementNumber';

export default function ButtonCoin({ text, className, ...props }: ButtonPropsType) {
  const { animationKey, buttonRef, isFlying, flyStyle, handleClick } = useFlyingAnimation();

  // const { startAnimation } = useIncrementNumber(20);
  return (
    <div className="h-full rounded-lg border-b-2 border-[#D9D9D9]">
      <button
        ref={buttonRef}
        style={{
          textShadow: !props.disabled ? '1.2px 1.2px 0px rgba(0, 0, 0, 0.3)' : 'none',
        }}
        // className={`h-full rounded-lg border-2 border-[#6B2D1A] px-[8px] text-[12px] ${props.disabled ? 'bg-[white] text-[#6B2D1A]' : 'bg-[#FF6535] text-white'} ${className}`}

        className={`h-full rounded-lg border-2 border-[#6B2D1A] px-[8px] text-[12px] ${
          text === 'Completion'
            ? 'bg-gray-200 text-[#6B2D1A]'
            : text === 'Earn'
              ? 'bg-[#FF6535] text-white'
              : text === 'Earned'
                ? 'bg-[white] text-[#6B2D1A]'
                : ''
        } ${className}`}
        {...props}
        onClick={(e) => {
          handleClick();
          // startAnimation();
          props.onClick?.(e);
        }}
      >
        {text}
        <AnimatePresence>
          {isFlying && (
            <motion.div
              key={animationKey}
              className="fixed"
              initial={{ opacity: 1, scale: 1 }}
              animate={{
                x: [flyStyle.left, flyStyle.midX, flyStyle.endLeft],
                y: [flyStyle.top, flyStyle.midY, flyStyle.endTop],
                rotate: [0, 180, 0],
                scale: [1, 1.2, 0.8],
                opacity: [1, 1, 0.8],
                transition: { duration: 1, ease: 'linear' },
              }}
              exit={{ opacity: 0 }}
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: 999,
                transform: 'translate(-50%, -50%)',
              }}
            >
              <img className="h-[35px] w-[30px]" src={CoinIcon} />
            </motion.div>
          )}
        </AnimatePresence>
      </button>
    </div>
  );
}
